import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-discord h-screen w-screen fixed" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("canvas", {
  id: "screen",
  class: "fixed top-0 left-0 cursor-crosshair"
}, null, -1)
const _hoisted_3 = { class: "fixed top-0 right-0 m-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolSidebar = _resolveComponent("ToolSidebar")!
  const _component_ZoomButton = _resolveComponent("ZoomButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_ToolSidebar),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_ZoomButton, { type: "+" }),
      _createVNode(_component_ZoomButton, { type: "-" })
    ])
  ]))
}